import Avatar from '@components/v2/ui/Avatar/Avatar';
import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import Typography from '@components/v2/ui/Typography/Typography';
import Box from '@mui/material/Box';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { UserMenuTestIds } from '../../../../../../utils/testIds/UserMenu.testIds';
import { useUserMenuButtonStyles } from './userMenuButton.styles';
interface UserMenuButtonProps {
  entityName: string;
  entityInitial: string;
  entityLogoUrl?: string;
  isOpen: boolean;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
}

const UserMenuButton = ({
  entityName,
  entityInitial,
  entityLogoUrl,
  isOpen,
  onClick,
}: UserMenuButtonProps) => {
  const { classes } = useUserMenuButtonStyles();

  return (
    <Button
      testId={UserMenuTestIds.TRIGGER}
      className={classes.root}
      color="secondary"
      onClick={onClick}
      size="large"
      shape="square"
      isActive={isOpen}
      endIcon={<Icon icon={isOpen ? ChevronUp : ChevronDown} size="md" />}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, overflow: 'hidden' }}>
        <Avatar
          src={entityLogoUrl}
          alt={entityName}
          fallback="initials"
          initials={entityInitial}
          size={20}
        />
        <Typography variant="body2" noWrap>
          {entityName}
        </Typography>
      </Box>
    </Button>
  );
};

export default UserMenuButton;
